import { useState } from "react"
import { useRouter } from "next/router"
import { Box, Field, Input, Link, Stack, Text } from "@chakra-ui/react"
import StyledButton from "components/registration/StyledButton"
import oktaRegistrationRedirect from "lib/oktaRegistrationRedirect"

export default function CustomLoginForm({ redirectUrl, pardotFormHandler, slug, preview, oauth, vendorOktaClientId }) {
    const router = useRouter()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState("")

    const handleSubmit = async e => {
        e.preventDefault()
        setIsLoading(true)
        setError("")

        try {
            const error = await oktaRegistrationRedirect({
                username: email,
                password,
                redirectUrl,
                pardotFormHandler,
                slug,
                preview,
                router,
                oauth,
                vendorOktaClientId,
            })
            if (error) {
                setError(error)
                return
            }
        } catch {
            setError("An error occurred. Please try again.")
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Box as="form" onSubmit={handleSubmit} color="#333" maxW="350px">
            <Stack gap={4}>
                {error && <Text color="error">{error}</Text>}
                <Field.Root>
                    <Field.Label>Email</Field.Label>
                    <Input
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                        autoComplete="email"
                    />
                </Field.Root>
                <Field.Root>
                    <Field.Label>Password</Field.Label>
                    <Input
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                        autoComplete="current-password"
                    />
                </Field.Root>
                <StyledButton type="submit" loading={isLoading}>
                    SIGN IN
                </StyledButton>
                <Text fontSize="sm">
                    <Link href={`${process.env.NEXT_PUBLIC_OKTA_ISSUER}/signin/forgot-password`} target="_blank">
                        Forgot password?
                    </Link>
                </Text>
            </Stack>
        </Box>
    )
}
